var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from "@uigovpe/components";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { goToOrLogin } from "../utils/authNavigate";
import { canContributeToHearing, canShowHearingResults, sortHearingItems, } from "../utils/participation";
var previewContainerStyle = {
    background: "#CED2D7",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    maxHeight: 320,
    overflow: "hidden",
    position: "relative",
    width: "100%",
};
var previewOverlayStyle = {
    background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 70%, rgba(255,255,255,1) 100%)",
    inset: 0,
    pointerEvents: "none",
    position: "absolute",
    zIndex: 1,
};
var previewBodyStyle = {
    maxHeight: 320,
    opacity: 0.7,
    overflow: "hidden",
    padding: "24px 24px 112px",
    position: "relative",
};
var bottomActionsStyle = {
    bottom: 20,
    display: "flex",
    gap: 16,
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    zIndex: 2,
};
var gradientButtonStyle = {
    background: "linear-gradient(180deg, #0034B7 0%, #001445 100%)",
    border: "none",
    boxShadow: "0px 2px 2px 0px #FFFFFF59 inset, 0px 4px 6px 0px #00000040",
};
var questionBlockStyle = {
    display: "grid",
    gap: 12,
    paddingBottom: 24,
};
var inputLikeStyle = {
    background: "#FFFFFF",
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    minHeight: 96,
    padding: 12,
    resize: "none",
    width: "100%",
};
var optionsColumnStyle = {
    display: "grid",
    gap: 8,
};
var optionRowStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
};
var PreviewAction = function (_a) {
    var disabled = _a.disabled, label = _a.label, onClick = _a.onClick, _b = _a.useSecondary, useSecondary = _b === void 0 ? false : _b;
    return (_jsx(Button, { disabled: disabled, label: label, onClick: onClick, severity: useSecondary ? "secondary" : undefined, style: useSecondary ? undefined : gradientButtonStyle }));
};
export var HearingContributionPreview = function (_a) {
    var contributionType = _a.contributionType, _b = _a.hasAnswered, hasAnswered = _b === void 0 ? false : _b, hearingId = _a.hearingId, hearingStatus = _a.hearingStatus, items = _a.items, _c = _a.loadingContribution, loadingContribution = _c === void 0 ? false : _c, openPrompt = _a.openPrompt;
    var navigate = useNavigate();
    var _d = useAuth(), hasPortalConnect = _d.hasPortalConnect, hasToken = _d.hasToken, isAuthenticated = _d.isAuthenticated, login = _d.login;
    var sortedItems = sortHearingItems(items || []);
    var hasRealItems = sortedItems.length > 0;
    var canContribute = canContributeToHearing(hearingStatus);
    var canSeeResults = canShowHearingResults(hearingStatus);
    var actionLabel = loadingContribution
        ? "Carregando..."
        : hasAnswered
            ? "Ver minha contribuição"
            : "Contribuir";
    var ensureAuthThen = function (path) {
        goToOrLogin({
            hasPortalConnect: hasPortalConnect,
            hasToken: hasToken,
            isAuthenticated: isAuthenticated,
            login: login,
            navigate: navigate,
            path: path,
        });
    };
    return (_jsxs("div", __assign({ style: previewContainerStyle }, { children: [_jsx("div", { style: previewOverlayStyle }), _jsx("div", __assign({ style: previewBodyStyle }, { children: contributionType === "open_contribution" ? (_jsxs("div", __assign({ style: questionBlockStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: ["1. ", openPrompt || "Contribuição aberta"] })), _jsx("textarea", { disabled: true, placeholder: "Os cidad\u00E3os responder\u00E3o aqui...", rows: 4, style: inputLikeStyle })] }))) : hasRealItems ? (sortedItems.map(function (item) { return (_jsxs("div", __assign({ style: questionBlockStyle }, { children: [_jsxs(Typography, __assign({ fontWeight: "medium" }, { children: [item.order, ". ", item.description, item.isRequired ? (_jsx("span", __assign({ style: { color: "#DC2626" } }, { children: " *" }))) : null] })), item.type === "text" ? (_jsx("textarea", { disabled: true, placeholder: "Resposta do cidad\u00E3o...", rows: 3, style: inputLikeStyle })) : (_jsx("div", __assign({ style: optionsColumnStyle }, { children: (item.publicHearingItemOptions || []).map(function (option) { return (_jsxs("label", __assign({ style: optionRowStyle }, { children: [_jsx("input", { disabled: true, type: item.type === "select_unique" ? "radio" : "checkbox" }), _jsx("span", { children: option.label })] }), option.id)); }) })))] }), item.id)); })) : (_jsx(Typography, { children: "O question\u00E1rio ser\u00E1 exibido aqui quando os itens estiverem dispon\u00EDveis." })) })), _jsxs("div", __assign({ style: bottomActionsStyle }, { children: [contributionType === "with_form" ? (_jsx(PreviewAction, { disabled: !canContribute && !hasAnswered, label: actionLabel, onClick: function () { return ensureAuthThen("/hearings/form/".concat(hearingId)); } })) : (_jsx(PreviewAction, { disabled: !canContribute && !hasAnswered, label: actionLabel, onClick: function () {
                            return ensureAuthThen("/hearings/contribution/".concat(hearingId));
                        } })), contributionType === "with_form" ||
                        contributionType === "open_contribution" ? (_jsx(PreviewAction, { disabled: !canSeeResults, label: "Ver respostas", onClick: function () {
                            return navigate(contributionType === "with_form"
                                ? "/hearings/form/".concat(hearingId, "?tab=responses")
                                : "/hearings/contribution/".concat(hearingId, "?tab=responses"));
                        }, useSecondary: true })) : null] }))] })));
};
